// translations.ts — Diccionario ES/EN completo de la landing page
// typeof es usado en "en: typeof es" garantiza que EN tenga
// exactamente las mismas keys que ES.

export const es = {
  nav: {
    services: 'Servicios',
    cases: 'Casos reales',
    roadmap: 'Tu camino',
    faq: 'FAQ',
    contact: 'Contacto',
    cta: 'Empezar ahora',
    langLabel: 'English',
  },

  hero: {
    badge1: 'Disponible ahora',
    badge2: 'Tecnología real · No Wix · No WordPress',
    badge3: 'Reinventamos tu negocio',

    h1Pre: 'De',
    h1LandingPage: 'landing page',
    h1Mid: 'a',
    h1b: 'sistema completo',
    h1c: ', con código e infraestructura real en la nube de AWS',

    subtitle:
      'Construimos tu landing page profesional y hacemos crecer tu sistema o negocio con tecnología real. Sin burocracia, sin agencias caras.',

    cta1: 'Quiero mi Landing Page',
    cta2: 'Ver todos los servicios',

    cred1: 'Migración a tecnología moderna',
    cred2: 'Sin agencias caras ni personal fijo',
    cred4: 'Soporte dedicado y personalizado',

    scrollHint: 'Descubre más',
  },

  impact: {
    heading: 'Los beneficios de invertir en presencia digital y sistemas',

    reasons: [
      {
        icon: 'search',
        title: 'Más clientes pueden encontrarte',
        desc: 'Una presencia digital profesional hace que tu negocio esté disponible cuando un cliente busca tus productos o servicios.',
      },
      {
        icon: 'rocket',
        title: 'Convierte visitas en oportunidades',
        desc: 'Una landing diseñada para conversión transforma campañas, búsquedas y redes sociales en contactos que puedes medir y dar seguimiento.',
      },
      {
        icon: 'globe',
        title: 'Disponible 24/7',
        desc: 'Captura solicitudes, prospectos y cotizaciones incluso cuando tu equipo no está disponible.',
      },
      {
        icon: 'robot',
        title: 'Menos trabajo manual',
        desc: 'Automatiza tareas repetitivas, captura de información, notificaciones y generación de reportes.',
      },
      {
        icon: 'link',
        title: 'Información centralizada',
        desc: 'Deja de buscar información entre Excel, correos, mensajes y diferentes aplicaciones.',
      },
      {
        icon: 'bar-chart',
        title: 'Decisiones con datos',
        desc: 'Visualiza ventas, clientes, operación e indicadores mediante dashboards y reportes actualizados.',
      },
      {
        icon: 'trend-up',
        title: 'Preparado para crecer',
        desc: 'Construye procesos y sistemas que puedan acompañar el crecimiento de tu empresa sin multiplicar el trabajo manual.',
      },
    ],

    metrics: [],
  },

  services: {
    tag: '',

    h2: 'Dos caminos para crecer con tecnología real',

    subtitle:
      'Ya sea que estés empezando desde cero o mejorando lo que ya tienes, tenemos la ruta correcta para ti.',

    track1Label: 'Construir - Empieza desde cero o expande',

    track2Label: 'Mejorar - Optimiza y evoluciona lo que ya tienes',

    mainBadge: 'Punto de entrada recomendado',

    mainTitle: 'Landing Page Profesional',

    mainDesc:
      'Tu primera impresión en internet, construida con tecnología real. Diseño moderno, copy estratégico y lista para escalar a un sistema completo.',

    mainPerks: [
      'Diseño a medida de tu marca e industria',
      'Formulario de contacto, cotización o agenda integrado',
      'SEO + velocidad de carga optimizados desde el día uno',
      'Integración con WhatsApp',
      'Dirección de internet o dominio por un año gratis',
      'Entorno demostrativo gratis por un año',
    ],

    mainCta: 'Quiero mi Landing',

    delivery: '5 días hábiles y tienes un demo para aprobación',

    visualLabel: 'Tu Landing Page Profesional',

    cards: {
      newSystem: {
        badge: 'Tu plataforma a medida',

        title: 'Sistema Nuevo desde Cero',

        desc: '¿Tu negocio creció y necesita una plataforma propia? Construimos sistemas web a medida y nos adaptamos a tus necesidades.',

        perks: [
          'Portales de clientes/empresas, paneles de administración y CRMs internos',
          'Inicio de sesión, creación de cuentas, roles y permisos de usuario',
          'Carga y administración de usuarios',
          'Notificaciones y carta de bienvenida',
          'Base de datos segura en la nube',
          'Módulos de administración, reportes, facturación, inventario, cotización o seguimiento',
          'Arquitectura escalable desde el primer día',
        ],

        ctaLabel: 'Quiero mi Sistema',

        delivery: 'Tiempo según alcance del proyecto',

        visualLabel:
          'Vista previa de un sistema a la medida — inicio de sesión y dashboard',
      },

      maintenance: {
        title: 'Mantenimiento y Estabilidad',

        desc: 'Tu sistema ya está corriendo y no puedes permitirte que falle. Revisamos el código y corregimos los errores definitivamente.',

        imageAlt: 'Panel de monitoreo de errores del sistema',

        perks: [
          'Diagnóstico técnico completo antes de cualquier intervención',
          'Corrección de bugs recurrentes de raíz',
          'Refactorización y documentación del sistema',
        ],

        note: 'Requiere acceso al código fuente y análisis previo.',
      },

      modernize: {
        title: 'Modernización de Interfaz',

        desc: '¿Tu sistema funciona pero se ve como del año 2010? Migramos la interfaz a una plataforma web moderna.',

        imageAlt: 'Sistema de escritorio con interfaz anticuada',

        perks: [
          'Nueva UI web manteniendo la lógica existente',
          'Migración gradual, sin bajar el sistema',
          'Responsive, rápida y compatible con cualquier dispositivo',
        ],
      },

      integration: {
        title: 'Integraciones y Nuevas Funcionalidades',

        desc: '¿Tu sistema necesita hablar con otros servicios? Conectamos APIs, plataformas de pago, ERPs o servicios externos.',

        perks: [
          'Integración con SAT, pasarelas de pago, ERP, CRM o APIs externas',
          'Nuevos módulos que se suman a lo que ya funciona',
          'Optimización de consultas y performance de base de datos',
        ],
      },
    },
  },

  cases: {
    tag: 'Casos reales',

    h2: 'Empresas que ya dieron el salto',

    subtitle: 'Resultados medibles, no promesas.',

    beforeLabel: '❌ Antes',
    afterLabel: '✓ Después',

    cases: [
      {
        sector: '🚚 Empresa de Logística y Distribución',

        title: 'Del Excel al panel en tiempo real',

        desc: 'Gestionaban rutas, entregas y facturación en hojas de cálculo compartidas.',

        before: [
          'Excel compartido con conflictos',
          'Reporte semanal: 4 horas',
          'Errores de captura frecuentes',
          'Sin visibilidad de rutas en curso',
        ],

        after: [
          'Panel unificado en tiempo real',
          'Reporte automático: 0 min',
          'Validación automática de datos',
          'GPS + estatus por entrega',
        ],

        metricLabel: 'Tiempo administrativo ahorrado',

        metricValue: '68%',
      },

      {
        sector: '🧾 Despacho Contable con clientes PyME',

        title: 'Facturación SAT integrada y sin errores',

        desc: 'Facturaban manualmente en el portal del SAT, uno a uno.',

        before: [
          'Facturación manual en SAT',
          '8+ horas/día en captura',
          'Errores de RFC y conceptos',
          'Sin historial centralizado',
        ],

        after: [
          'Emisión masiva desde el sistema',
          '<45 min para el mismo volumen',
          'Validación automática de datos',
          'Historial por cliente exportable',
        ],

        metricLabel: 'Reducción en tiempo de facturación',

        metricValue: '91%',
      },

      {
        sector: '🏪 Retail con 3 sucursales',

        title: 'Inventario unificado, ventas visibles desde casa',

        desc: 'Cada sucursal manejaba su propio inventario.',

        before: [
          '3 sistemas desconectados',
          'Inventario desactualizado',
          'Sin comparativo entre sucursales',
          'Mermas sin rastrear',
        ],

        after: [
          'Un sistema, 3 sucursales en tiempo real',
          'Stock sincronizado automáticamente',
          'Dashboard comparativo por tienda',
          'Alertas de merma y robo detectado',
        ],

        metricLabel: 'Visibilidad del negocio en tiempo real',

        metricValue: '100%',
      },
    ],
  },

  roadmap: {
    tag: 'Tu camino',

    h2: 'Empieza pequeño. Escala sin límites.',

    subtitle: 'No necesitas construir todo desde el día uno.',

    steps: [
      {
        title: 'Landing Page',

        desc: 'Tu presencia profesional en internet. Genera leads y convierte visitantes en clientes.',

        time: '5 días hábiles',
      },

      {
        title: 'Módulos y Funcionalidades',

        desc: 'Agrega cotizadores, portales de clientes, integraciones de pago o lo que tu operación requiera.',

        time: 'Según requerimientos',
      },

      {
        title: 'Sistema Completo',

        desc: 'Cuando tu negocio lo exige, construimos la plataforma completa — escalable, segura y en la nube.',

        time: 'Tu plataforma propia',
      },
    ],
  },

  contrast: {
    tag: 'Por qué elegirnos',

    h2: 'No somos Wix. Tampoco WordPress. Tampoco una agencia cara.',

    colFeature: 'Característica',
    colWix: 'Wix / No-code',
    colWordpress: 'WordPress',
    colAgency: 'Agencia',
    colUs: 'ReInvent-X',

    rows: [
      {
        feature: 'Diseño profesional y a medida',

        wix: {
          text: 'Plantillas genéricas',
        },

        wordpress: {
          text: 'Depende del theme/plugin',
        },

        agency: {
          text: 'Sí, pero sin backend',
        },

        us: 'Diseño + código real',
      },

      {
        feature: 'Puede escalar a sistema completo',

        wix: {
          icon: 'cross',
          text: 'No',
        },

        wordpress: {
          icon: 'cross',
          text: 'Se vuelve lento y frágil',
        },

        agency: {
          icon: 'cross',
          text: 'No programan',
        },

        us: 'Es el plan desde día 1',
      },

      {
        feature: 'Interlocutor técnico real',

        wix: {
          text: 'Soporte genérico',
        },

        wordpress: {
          text: 'Foros y soporte de plugins',
        },

        agency: {
          text: 'Ejecutivo de cuenta',
        },

        us: 'Líder técnico directo',
      },

      {
        feature: 'Pago por resultados',

        wix: {
          text: 'Suscripción mensual',
        },

        wordpress: {
          text: 'Hosting + plugins de por vida',
        },

        agency: {
          text: 'Proyecto cerrado rígido',
        },

        us: 'Anticipo mínimo + avance',
      },

      {
        feature: 'Tiempo de entrega',

        wix: {
          text: 'Inmediato pero limitado',
        },

        wordpress: {
          text: 'Semanas configurando plugins',
        },

        agency: {
          text: '4–8 semanas',
        },

        us: '5–15 días hábiles',
      },

      {
        feature: 'La documentación es tuya',

        wix: {
          icon: 'cross',
          text: 'Depende de su plataforma',
        },

        wordpress: {
          text: 'Es tuyo, pero no lo entiendes',
        },

        agency: {
          icon: 'cross',
          text: 'No aplica',
        },

        us: 'Siempre, desde el inicio',
      },
    ],
  },

  why: {
    tag: 'Por qué nosotros',

    h2: 'Lo que nos hace diferentes',

    items: [
      {
        emoji: 'credit-card',

        title: 'Pago por Avance Real',

        desc: 'Pagas conforme ves resultados. Anticipo mínimo para iniciar, y el resto por hitos que tú validas.',
      },

      {
        emoji: 'shield',

        title: 'Estabilidad Garantizada',

        desc: 'Ves el producto funcionando en nuestro entorno demo antes de cualquier pago final.',
      },

      {
        emoji: 'briefcase',

        title: 'Sin Nómina de TI que Mantener',

        desc: 'Olvídate de contratar y sostener un equipo técnico interno. Solo pagas cuando tu sistema necesita crecer.',
      },

      {
        emoji: 'flask',

        title: 'Entorno de Pruebas Antes de Producción',

        desc: 'Generamos un entorno de staging para que valides los cambios con tus propios ojos. Con tu aprobación, desplegamos al entorno productivo con confianza.',
      },

      {
        emoji: 'pencil',

        title: 'Auditoría y Trazabilidad Total',

        desc: 'Registramos quién hizo cada cambio y cuándo. Trazabilidad completa para detectar o resolver cualquier incidente.',
      },
    ],
  },

  faq: {
    tag: 'FAQ',

    h2: 'Preguntas frecuentes',

    items: [
      {
        id: 'faq-1',

        question:
          '¿Tomas decisiones importantes sin saber realmente qué está pasando en tus ventas u operación?',

        answer:
          'Si no tienes reportes claros y a tiempo, estás decidiendo a ciegas. Construimos dashboards que te muestran tus números en tiempo real, sin depender de que alguien los arme a mano.',
      },

      {
        id: 'faq-2',

        question:
          '¿Generar un reporte te toma horas porque hay que juntar información de varios lados?',

        answer:
          'Ese tiempo se puede reducir a minutos. Automatizamos la generación de reportes para que estén listos cuando los necesites, no cuando alguien tenga tiempo de armarlos.',
      },

      {
        id: 'faq-3',

        question:
          '¿Tu información vive regada entre Excel, correos y distintas aplicaciones, y nadie sabe cuál versión es la correcta?',

        answer:
          'Es una de las señales más claras de que necesitas un sistema centralizado. Unificamos tu operación en un solo lugar, con permisos claros y datos siempre actualizados.',
      },

      {
        id: 'faq-4',

        question:
          '¿Tienes un sistema viejo o con interfaz anticuada y te da miedo tocarlo porque ya está en producción?',

        answer:
          'Lo entendemos. Empezamos con un diagnóstico honesto y migramos de forma gradual, sin apagar tu sistema actual, hasta que la nueva versión esté validada.',
      },

      {
        id: 'faq-5',

        question:
          '¿Tu sistema funciona pero cada vez es más lento o tiene errores que nadie termina de resolver del todo?',

        answer:
          'Los parches temporales solo esconden el problema. Hacemos un diagnóstico técnico completo y corregimos los bugs desde la raíz, dejando el sistema documentado.',
      },

      {
        id: 'faq-6',

        question: '¿Por qué piden solo un pequeño anticipo?',

        answer:
          'Porque confiamos en nuestro trabajo. El anticipo cubre la firma del contrato y el inicio del diagnóstico.',
      },

      {
        id: 'faq-7',

        question: '¿Con quién me comunico durante el proyecto?',

        answer:
          'Directamente con el líder técnico que coordina el desarrollo. Sin ejecutivos de cuenta intermediarios.',
      },
    ],
  },

  form: {
    tag: '',

    sideTitle: 'Cuéntanos tu reto. Te respondemos en horas, no días.',

    sideDesc:
      'Nuestro formulario analiza tu proyecto en tiempo real y asigna una prioridad interna.',

    scoreCards: [
      {
        icon: 'fire',

        title: 'Prioridad Alta — Cierre inmediato',

        desc: 'Landing page + urgente + presupuesto definido. Respuesta del líder técnico en < 4 horas.',
      },

      {
        icon: 'lightning',

        title: 'Sistema Nuevo — Alto potencial',

        desc: 'Quieren sistema desde cero, presupuesto abierto o alto.',
      },

      {
        icon: 'warning',

        title: 'Modernización / Mantenimiento — Filtro previo',

        desc: 'Verificar acceso al código fuente antes de cotizar.',
      },

      {
        icon: 'trend-down',

        title: 'Baja Prioridad',

        desc: 'Menos de 10 usuarios, sin prisa y sin presupuesto.',
      },
    ],

    formTitle: 'Cuéntanos de tu proyecto:',

    labelCompany: 'Nombre de tu empresa:',

    labelSector: 'Sector de tu empresa',

    sectorOptions: [
      {
        value: 'restaurant',
        label: 'Restaurante / Cafetería',
        styleUi: 'Cálido, editorial',
      },

      {
        value: 'consulting',
        label: 'Consultoría / Despacho',
        styleUi: 'Corporativo Premium',
      },

      {
        value: 'technology',
        label: 'Tecnología / Software',
        styleUi: 'Tech moderno',
      },

      {
        value: 'construction',
        label: 'Construcción / Arquitectura',
        styleUi: 'Industrial elegante',
      },

      {
        value: 'healthcare',
        label: 'Clínica / Consultorio',
        styleUi: 'Minimalista, confiable',
      },

      {
        value: 'finance',
        label: 'Contabilidad / Finanzas',
        styleUi: 'Corporativo',
      },

      {
        value: 'real-estate',
        label: 'Inmobiliaria',
        styleUi: 'Fotográfico premium',
      },

      {
        value: 'hospitality',
        label: 'Hotel / Hospedaje',
        styleUi: 'Inmersivo',
      },

      {
        value: 'automotive',
        label: 'Taller / Servicio automotriz',
        styleUi: 'Industrial moderno',
      },

      {
        value: 'education',
        label: 'Escuela / Capacitación',
        styleUi: 'Dinámico',
      },

      {
        value: 'ecommerce',
        label: 'E-commerce / Tienda',
        styleUi: 'Comercial',
      },

      {
        value: 'professional-services',
        label: 'Servicios Profesionales',
        styleUi: 'Minimal Corporativo',
      },

      {
        value: 'other',
        label: 'Otro',
        styleUi: 'Otro',
      },
    ],

    labellocation: '¿Te ubicas en Mérida?:',

    labelNeed: '¿Qué requieres?:',

    labelOwnership: '¿El sistema actual es de la empresa?:',

    labelUsers: 'Usuarios que usarán el sistema:',

    labelProblem: 'Cuéntanos la necesidad:',

    problemPlaceholder:
      'Describe brevemente qué quieres lograr o qué problema enfrentas hoy...',

    labelTimeline: '¿Cuándo lo requieres?',

    labelBudget: 'Presupuesto estimado:',

    labelPhone: 'Teléfono:',

    labelEmail: 'Correo electrónico:',

    labelContactTime: 'Horario de contacto:',

    contactTimeOptions: [
      {
        value: 'morning',
        label: 'Mañana (9am–12pm)',
      },
      {
        value: 'afternoon',
        label: 'Tarde (1pm–5pm)',
      },
      {
        value: 'evening',
        label: 'Noche (6pm–9pm)',
      },
      {
        value: 'anytime',
        label: 'Cualquier horario',
      },
    ],

    labelPromoCode: 'Código promocional (opcional):',

    promoCodePlaceholder: 'Ej: PROMO2026',

    submitBtn: 'Enviar mi proyecto con Tech Lead a revisión...',

    submitting: 'Enviando...',

    successTitle: '¡Proyecto recibido!',

    successDesc:
      'El Tech Lead revisará tu proyecto y te contactará en el tiempo indicado.',

    sendAnother: 'Enviar otro proyecto',

    needOptions: [
      {
        value: 'landing',
        label: 'Landing Page',
        icon: '',
      },

      {
        value: 'new-system',
        label: 'Sistema nuevo traje a la medida',
        icon: '',
      },

      {
        value: 'maintenanceFix',
        label: 'Mantenimiento / Corrección',
        icon: '',
      },

      {
        value: 'maintenanceImprove',
        label: 'Mantenimiento / Mejora',
        icon: '',
      },

      {
        value: 'modernize',
        label: 'Modernización / Migración',
        icon: '',
      },

      {
        value: 'integration',
        label: 'Integración',
        icon: '',
      },
    ],

    ownershipOptions: [
      {
        value: 'yes',
        label: 'Sí, es nuestro',
        icon: '',
      },

      {
        value: 'third',
        label: 'Es de terceros',
        icon: '',
      },

      {
        value: 'new',
        label: 'No existe aún',
        icon: '',
      },
    ],

    usersOptions: [
      {
        value: 'equals0',
        label: '= 0 usuarios (Landing Page)',
      },

      {
        value: 'equals1',
        label: '= 1 usuario Administrador',
      },

      {
        value: 'less10',
        label: '< 10 usuarios',
      },

      {
        value: '11-50',
        label: '11 – 50',
      },

      {
        value: '51-200',
        label: '51 – 200',
      },

      {
        value: '200+',
        label: '> 200 usuarios',
      },
    ],

    timelineOptions: [
      {
        value: 'basic',
        label: '5 días hábiles',
        icon: '',
      },

      {
        value: 'urgent',
        label: 'Urgente (< 1 mes)',
        icon: '',
      },

      {
        value: '1-2m',
        label: '1 – 2 meses',
        icon: '',
      },

      {
        value: '3m+',
        label: '> 3 meses',
        icon: '',
      },
    ],

    budgetOptions: [
      {
        value: 'eq2500',
        label: '= $2,500 MXN',
      },

      {
        value: '2500-10k',
        label: '> $2,500 MXN y < $10,000 MXN',
      },

      {
        value: '10k-30k',
        label: '> $10,000 MXN y < $30,000 MXN',
      },

      {
        value: '30k-50k',
        label: '> $30,000 MXN y < $50,000 MXN',
      },

      {
        value: '50k+',
        label: '> $50,000 MXN',
      },

      {
        value: 'hourly',
        label: 'Por hora',
      },
    ],

    toastSuccess: {
      title: '¡Recibido!',
      subtitle: 'El Tech Lead te contactará pronto.',
    },

    toastError: {
      title: 'Error al enviar',
      subtitle: 'Por favor intenta de nuevo en un momento.',
    },

    errorMsg: 'Error al enviar. Intenta de nuevo.',

    invalidEmail: 'Ingresa un correo electrónico válido.',

    invalidPhone: 'Ingresa un número de teléfono válido (solo dígitos).',
  },

  cta: {
    tag: '',

    h2a: 'Tu negocio, con',
    h2b: 'tecnología real',
    h2c: '. Esta semana.',

    subtitle:
      'La landing page más efectiva que has tenido, lista en 5 días hábiles. Sin burocracia.',

    cta1: 'Empezar ahora',

    cta2: '¿Tienes dudas? Ver FAQ',

    guarantee: '',
  },

  footer: {
    desc: 'Tecnología real para PyMEs. Sin burocracia.',

    colServices: 'Servicios',
    colCompany: 'Empresa',

    rights: 'Todos los derechos reservados',

    privacy: 'Privacidad y seguridad garantizadas',
  },
} as const;

// ═══════════════════════════════════════════════════════════════════════
// ENGLISH
// La estructura debe mantenerse idéntica a ES.
// ═══════════════════════════════════════════════════════════════════════

export const en: typeof es = {
  nav: {
    services: 'Services',
    cases: 'Real Cases',
    roadmap: 'Your Path',
    faq: 'FAQ',
    contact: 'Contact',
    cta: 'Get Started',
    langLabel: 'Español',
  },

  hero: {
    badge1: 'Available Now',
    badge2: 'Real Technology · No Wix · No WordPress',
    badge3: 'We ReInvent Your Business',

    h1Pre: 'From',
    h1LandingPage: 'landing page',
    h1Mid: 'to a',
    h1b: 'complete system',
    h1c: ', with real code and infrastructure on AWS',

    subtitle:
      'We build your professional landing page and help your system or business grow with real technology. No bureaucracy, no expensive agencies.',

    cta1: 'I Want My Landing Page',

    cta2: 'View All Services',

    cred1: 'Migration to modern technology',

    cred2: 'No expensive agencies or fixed staff',

    cred4: 'Dedicated, personalized support',

    scrollHint: 'Discover More',
  },

  impact: {
    heading:
      'The Benefits of Investing in a Digital Presence and Business Systems',

    reasons: [
      {
        icon: 'search',

        title: 'More Customers Can Find You',

        desc: 'A professional digital presence makes your business available whenever a customer searches for your products or services.',
      },

      {
        icon: 'rocket',

        title: 'Turn Visits into Opportunities',

        desc: 'A landing page designed for conversion turns campaigns, searches, and social media into leads you can measure and follow up on.',
      },

      {
        icon: 'globe',

        title: 'Available 24/7',

        desc: 'Capture requests, leads, and quote inquiries even when your team is unavailable.',
      },

      {
        icon: 'robot',

        title: 'Less Manual Work',

        desc: 'Automate repetitive tasks, data capture, notifications, and generate report.',
      },

      {
        icon: 'link',

        title: 'Centralized Information',

        desc: 'Stop searching for information across spreadsheets, emails, messages, and different apps.',
      },

      {
        icon: 'bar-chart',

        title: 'Data-Driven Decisions',

        desc: 'Visualize sales, customers, operations, and KPIs through dashboards and up-to-date reports.',
      },

      {
        icon: 'trend-up',

        title: 'Built to Grow',

        desc: "Build processes and systems that can keep up with your company's growth without multiplying manual work.",
      },
    ],

    metrics: [],
  },

  services: {
    tag: '',

    h2: 'Two Paths to Grow with Real Technology',

    subtitle:
      "Whether you're starting from scratch or improving what you already have, we have the right path for you.",

    track1Label: 'Build — Start from Scratch or Expand',

    track2Label: 'Improve — Optimize and Evolve What You Already Have',

    mainBadge: 'Recommended Starting Point',

    mainTitle: 'Professional Landing Page',

    mainDesc:
      'Your first impression online, built with real technology. Modern design, strategic copy, and ready to scale into a complete business system.',

    mainPerks: [
      'Custom design tailored to your brand and industry',
      'Integrated contact, quote, or appointment form',
      'SEO and loading speed optimized from day one',
      'WhatsApp integration',
      'Free domain name for one year',
      'Free demo environment for one year',
    ],

    mainCta: 'I Want My Landing Page',

    delivery: 'Get a demo for approval within 5 business days',

    visualLabel: 'Your Professional Landing Page',

    cards: {
      newSystem: {
        badge: 'Your Custom Platform',

        title: 'New System Built from Scratch',

        desc: 'Has your business grown to the point where you need your own platform? We build custom web systems tailored to your specific needs.',

        perks: [
          'Customer and business portals, admin dashboards, and internal CRMs',
          'Login, account creation, user roles, and permissions',
          'User onboarding and management',
          'Welcome notifications',
          'Secure cloud database',
          'Administration, reporting, billing, inventory, quoting, and tracking modules',
          'Scalable architecture from day one',
        ],

        ctaLabel: 'I Want My System',

        delivery: 'Timeline based on project scope',

        visualLabel: 'Preview of a custom-built system — login and dashboard',
      },

      maintenance: {
        title: 'Maintenance & Stability',

        desc: "Your system is already running and you can't afford downtime. We review the code and fix recurring problems at their root cause.",

        imageAlt: 'System error monitoring dashboard',

        perks: [
          'Complete technical assessment before any intervention',
          'Root-cause fixes for recurring bugs',
          'System refactoring and documentation',
        ],

        note: 'Requires source code access and prior technical analysis.',
      },

      modernize: {
        title: 'Interface Modernization',

        desc: 'Does your system work but look like it was built in 2010? We migrate its interface to a modern web platform.',

        imageAlt: 'Desktop system with an outdated interface',

        perks: [
          'Modern web UI while preserving existing business logic',
          'Gradual migration with no system downtime',
          'Responsive, fast, and compatible with any device',
        ],
      },

      integration: {
        title: 'Integrations & New Features',

        desc: 'Does your system need to communicate with other services? We connect APIs, payment gateways, ERPs, and external platforms.',

        perks: [
          'Integration with SAT, payment gateways, ERP, CRM, and external APIs',
          'New modules added without disrupting what already works',
          'Database query optimization and performance tuning',
        ],
      },
    },
  },

  cases: {
    tag: 'Real Cases',

    h2: 'Companies That Have Already Made the Leap',

    subtitle: 'Measurable results, not promises.',

    beforeLabel: '❌ Before',

    afterLabel: '✓ After',

    cases: [
      {
        sector: '🚚 Logistics & Distribution Company',

        title: 'From Excel to a Real-Time Dashboard',

        desc: 'They managed routes, deliveries, and billing using shared spreadsheets.',

        before: [
          'Shared Excel files with conflicts',
          'Weekly report: 4 hours',
          'Frequent data-entry errors',
          'No visibility into active routes',
        ],

        after: [
          'Unified real-time dashboard',
          'Automated report: 0 min',
          'Automatic data validation',
          'GPS + status for every delivery',
        ],

        metricLabel: 'Administrative Time Saved',

        metricValue: '68%',
      },

      {
        sector: '🧾 Accounting Firm Serving SMB Clients',

        title: 'Integrated, Error-Free SAT Invoicing',

        desc: 'Invoices were created manually in the SAT portal, one at a time.',

        before: [
          'Manual invoicing through SAT',
          '8+ hours/day spent on data entry',
          'RFC and invoice-item errors',
          'No centralized history',
        ],

        after: [
          'Bulk invoice issuance directly from the system',
          '<45 min for the same volume',
          'Automatic data validation',
          'Exportable history for each client',
        ],

        metricLabel: 'Reduction in Invoicing Time',

        metricValue: '91%',
      },

      {
        sector: '🏪 Retail Business with 3 Locations',

        title: 'Unified Inventory, Sales Visible from Anywhere',

        desc: 'Each location managed its own inventory independently.',

        before: [
          '3 disconnected systems',
          'Outdated inventory information',
          'No comparison between locations',
          'Untracked inventory shrinkage',
        ],

        after: [
          'One system, 3 locations in real time',
          'Automatically synchronized stock',
          'Comparative dashboard by location',
          'Shrinkage and theft alerts',
        ],

        metricLabel: 'Real-Time Business Visibility',

        metricValue: '100%',
      },
    ],
  },

  roadmap: {
    tag: 'Your Path',

    h2: 'Start Small. Scale Without Limits.',

    subtitle: "You don't need to build everything from day one.",

    steps: [
      {
        title: 'Landing Page',

        desc: 'Your professional online presence. Generate leads and convert visitors into customers.',

        time: '5 business days',
      },

      {
        title: 'Modules & Features',

        desc: 'Add quoting tools, customer portals, payment integrations, or anything your operation requires.',

        time: 'Based on requirements',
      },

      {
        title: 'Complete System',

        desc: 'When your business requires it, we build the complete platform — scalable, secure, and cloud-based.',

        time: 'Your Own Platform',
      },
    ],
  },

  contrast: {
    tag: 'Why Choose Us',

    h2: "We're Not Wix. Not WordPress. And Not an Expensive Agency.",

    colFeature: 'Feature',

    colWix: 'Wix / No-code',

    colWordpress: 'WordPress',

    colAgency: 'Agency',

    colUs: 'ReInvent-X',

    rows: [
      {
        feature: 'Professional Custom Design',

        wix: {
          text: 'Generic templates',
        },

        wordpress: {
          text: 'Depends on the theme/plugin',
        },

        agency: {
          text: 'Yes, but often without a backend',
        },

        us: 'Custom Design + Real Code',
      },

      {
        feature: 'Can Scale into a Complete System',

        wix: {
          icon: 'cross',
          text: 'No',
        },

        wordpress: {
          icon: 'cross',
          text: 'Can become slow and fragile',
        },

        agency: {
          icon: 'cross',
          text: 'Development may not be included',
        },

        us: 'Planned from Day One',
      },

      {
        feature: 'Direct Technical Contact',

        wix: {
          text: 'Generic support',
        },

        wordpress: {
          text: 'Forums and plugin support',
        },

        agency: {
          text: 'Account executive',
        },

        us: 'Direct Tech Lead',
      },

      {
        feature: 'Pay for Results',

        wix: {
          text: 'Monthly subscription',
        },

        wordpress: {
          text: 'Hosting + ongoing plugin costs',
        },

        agency: {
          text: 'Rigid fixed-scope project',
        },

        us: 'Minimal Deposit + Progress Payments',
      },

      {
        feature: 'Delivery Time',

        wix: {
          text: 'Immediate but limited',
        },

        wordpress: {
          text: 'Weeks configuring plugins',
        },

        agency: {
          text: '4–8 weeks',
        },

        us: '5–15 Business Days',
      },

      {
        feature: 'You Own the Documentation',

        wix: {
          icon: 'cross',
          text: 'Depends on their platform',
        },

        wordpress: {
          text: 'You own it, but it can be difficult to maintain',
        },

        agency: {
          icon: 'cross',
          text: 'Not always included',
        },

        us: 'Always, from the Start',
      },
    ],
  },

  why: {
    tag: 'Why Us',

    h2: 'What Makes Us Different',

    items: [
      {
        emoji: 'credit-card',

        title: 'Pay for Real Progress',

        desc: 'You pay as you see results. A minimal deposit gets the project started, and the remaining payments are tied to milestones you approve.',
      },

      {
        emoji: 'shield',

        title: 'Guaranteed Stability',

        desc: 'You see the product working in our demo environment before making any final payment.',
      },

      {
        emoji: 'briefcase',

        title: 'No In-House IT Payroll to Maintain',

        desc: 'Forget about hiring and maintaining a full-time technical team. You only pay when your system needs to grow.',
      },

      {
        emoji: 'flask',

        title: 'Staging Environment Before Production',

        desc: 'We create a staging environment so you can validate changes yourself. Once you approve them, we confidently deploy to production.',
      },

      {
        emoji: 'pencil',

        title: 'Complete Audit Trail and Traceability',

        desc: 'We log who made each change and when. Full traceability to detect or resolve any incident quickly.',
      },
    ],
  },

  faq: {
    tag: 'FAQ',

    h2: 'Frequently Asked Questions',

    items: [
      {
        id: 'faq-1',

        question:
          "Are you making important decisions without really knowing what's happening in your sales or operations?",

        answer:
          "Without clear, timely reports, you're deciding blind. We build dashboards that show your numbers in real time, without depending on someone putting a report together by hand.",
      },

      {
        id: 'faq-2',

        question:
          'Does putting together a report take you hours because you have to gather information from several places?',

        answer:
          "That time can shrink to minutes. We automate report generation so they're ready when you need them, not whenever someone has time to build them.",
      },

      {
        id: 'faq-3',

        question:
          'Is your information scattered across Excel, emails, and different apps, with no one sure which version is the correct one?',

        answer:
          "That's one of the clearest signs you need a centralized system. We unify your operation in one place, with clear permissions and data that's always up to date.",
      },

      {
        id: 'faq-4',

        question:
          "Do you have an old system or an outdated interface you're afraid to touch because it's already in production?",

        answer:
          'We understand. We start with an honest assessment and migrate gradually, without shutting down your current system, until the new version is validated.',
      },

      {
        id: 'faq-5',

        question:
          'Does your system work, but keeps getting slower or has bugs no one ever fully resolves?',

        answer:
          'Temporary patches just hide the problem. We run a full technical assessment and fix bugs at the root, leaving the system documented.',
      },

      {
        id: 'faq-6',

        question: 'Why do you only require a small deposit?',

        answer:
          'Because we trust our work. The deposit covers the contract signing and the initial technical assessment.',
      },

      {
        id: 'faq-7',

        question: 'Who will I communicate with during the project?',

        answer:
          'Directly with the Tech Lead coordinating the development. No account executives acting as intermediaries.',
      },
    ],
  },

  form: {
    tag: '',

    sideTitle: 'Tell Us Your Challenge. We Respond in Hours, Not Days.',

    sideDesc:
      'Our form analyzes your project in real time and assigns an internal priority.',

    scoreCards: [
      {
        icon: 'fire',

        title: 'High Priority — Immediate Follow-Up',

        desc: 'Landing page + urgent timeline + defined budget. Tech Lead response in under 4 hours.',
      },

      {
        icon: 'lightning',

        title: 'New System — High Potential',

        desc: 'A new system built from scratch with an open or substantial budget.',
      },

      {
        icon: 'warning',

        title: 'Modernization / Maintenance — Initial Review',

        desc: 'Source code access must be verified before providing a quote.',
      },

      {
        icon: 'trend-down',

        title: 'Low Priority',

        desc: 'Fewer than 10 users, no urgency, and no defined budget.',
      },
    ],

    formTitle: 'Tell Us About Your Project:',

    labelCompany: 'Company Name:',

    labelSector: 'Business Sector:',

    sectorOptions: [
      {
        value: 'restaurant',
        label: 'Restaurant / Café',
        styleUi: 'Warm, Editorial',
      },

      {
        value: 'consulting',
        label: 'Consulting / Professional Firm',
        styleUi: 'Premium Corporate',
      },

      {
        value: 'technology',
        label: 'Technology / Software',
        styleUi: 'Modern Tech',
      },

      {
        value: 'construction',
        label: 'Construction / Architecture',
        styleUi: 'Elegant Industrial',
      },

      {
        value: 'healthcare',
        label: 'Clinic / Medical Practice',
        styleUi: 'Minimalist, Trustworthy',
      },

      {
        value: 'finance',
        label: 'Accounting / Finance',
        styleUi: 'Corporate',
      },

      {
        value: 'real-estate',
        label: 'Real Estate',
        styleUi: 'Premium Photography',
      },

      {
        value: 'hospitality',
        label: 'Hotel / Hospitality',
        styleUi: 'Immersive',
      },

      {
        value: 'automotive',
        label: 'Auto Repair / Automotive Services',
        styleUi: 'Modern Industrial',
      },

      {
        value: 'education',
        label: 'School / Training',
        styleUi: 'Dynamic',
      },

      {
        value: 'ecommerce',
        label: 'E-commerce / Online Store',
        styleUi: 'Commercial',
      },

      {
        value: 'professional-services',
        label: 'Professional Services',
        styleUi: 'Minimal Corporate',
      },

      {
        value: 'other',
        label: 'Other',
        styleUi: 'Other',
      },
    ],

    labellocation: 'Are You Located in Mérida?:',

    labelNeed: 'What Do You Need?:',

    labelOwnership: 'Does Your Company Own the Current System?:',

    labelUsers: 'Number of Users:',

    labelProblem: 'Tell Us What You Need:',

    problemPlaceholder:
      'Briefly describe what you want to achieve or the problem you are facing today...',

    labelTimeline: 'When Do You Need It?',

    labelBudget: 'Estimated Budget:',

    labelPhone: 'Phone:',

    labelEmail: 'Email:',

    labelContactTime: 'Preferred Contact Time:',

    contactTimeOptions: [
      {
        value: 'morning',
        label: 'Morning (9am–12pm)',
      },

      {
        value: 'afternoon',
        label: 'Afternoon (1pm–5pm)',
      },

      {
        value: 'evening',
        label: 'Evening (6pm–9pm)',
      },

      {
        value: 'anytime',
        label: 'Any Time',
      },
    ],

    labelPromoCode: 'Promo Code (optional):',

    promoCodePlaceholder: 'E.g.: PROMO2026',

    submitBtn: 'Submit My Project for Tech Lead Review...',

    submitting: 'Submitting...',

    successTitle: 'Project Received!',

    successDesc:
      'Our Tech Lead will review your project and contact you within the indicated timeframe.',

    sendAnother: 'Submit Another Project',

    needOptions: [
      {
        value: 'landing',
        label: 'Landing Page',
        icon: '',
      },

      {
        value: 'new-system',
        label: 'New Custom-Built System',
        icon: '',
      },

      {
        value: 'maintenanceFix',
        label: 'Maintenance / Bug Fixes',
        icon: '',
      },

      {
        value: 'maintenanceImprove',
        label: 'Maintenance / Improvements',
        icon: '',
      },

      {
        value: 'modernize',
        label: 'Modernization / Migration',
        icon: '',
      },

      {
        value: 'integration',
        label: 'Integration',
        icon: '',
      },
    ],

    ownershipOptions: [
      {
        value: 'yes',
        label: 'Yes, We Own It',
        icon: '',
      },

      {
        value: 'third',
        label: 'Third-Party System',
        icon: '',
      },

      {
        value: 'new',
        label: "It Doesn't Exist Yet",
        icon: '',
      },
    ],

    usersOptions: [
      {
        value: 'equals0',
        label: '= 0 Users (Landing Page)',
      },

      {
        value: 'equals1',
        label: '= 1 Administrator',
      },

      {
        value: 'less10',
        label: '< 10 Users',
      },

      {
        value: '11-50',
        label: '11 – 50',
      },

      {
        value: '51-200',
        label: '51 – 200',
      },

      {
        value: '200+',
        label: '> 200 Users',
      },
    ],

    timelineOptions: [
      {
        value: 'basic',
        label: '5 Business Days',
        icon: '',
      },

      {
        value: 'urgent',
        label: 'Urgent (< 1 Month)',
        icon: '',
      },

      {
        value: '1-2m',
        label: '1 – 2 Months',
        icon: '',
      },

      {
        value: '3m+',
        label: '> 3 Months',
        icon: '',
      },
    ],

    budgetOptions: [
      {
        value: 'eq2500',
        label: '= $2,500 MXN',
      },

      {
        value: '2500-10k',
        label: '> $2,500 MXN and < $10,000 MXN',
      },

      {
        value: '10k-30k',
        label: '> $10,000 MXN and < $30,000 MXN',
      },

      {
        value: '30k-50k',
        label: '> $30,000 MXN and < $50,000 MXN',
      },

      {
        value: '50k+',
        label: '> $50,000 MXN',
      },

      {
        value: 'hourly',
        label: 'Hourly ($1,000 MXN)',
      },
    ],

    toastSuccess: {
      title: 'Received!',

      subtitle: 'Our Tech Lead will contact you soon.',
    },

    toastError: {
      title: 'Submission Error',

      subtitle: 'Please try again in a moment.',
    },

    errorMsg: 'Submission error. Please try again.',

    invalidEmail: 'Enter a valid email address.',

    invalidPhone: 'Enter a valid phone number (digits only).',
  },

  cta: {
    tag: '',

    h2a: 'Your Business, Powered by',

    h2b: 'Real Technology',

    h2c: '. This Week.',

    subtitle:
      'The most effective landing page you have ever had, ready in 5 business days. No bureaucracy.',

    cta1: 'Get Started',

    cta2: 'Have Questions? See FAQ',

    guarantee: '',
  },

  footer: {
    desc: 'Real Technology for SMBs. No Bureaucracy.',

    colServices: 'Services',

    colCompany: 'Company',

    rights: 'All Rights Reserved',

    privacy: 'Privacy and Security Guaranteed',
  },
} as const;

// ═══════════════════════════════════════════════════════════════════════
// TYPES
// ═══════════════════════════════════════════════════════════════════════

export type Translations = typeof es;

export type Language = 'es' | 'en';

export const translations: Record<Language, Translations> = {
  es,
  en,
};
